import React, { ChangeEvent, useEffect, useState } from 'react'
import { Col, Row } from 'antd'
import styled from 'styled-components'
import { RegisterWasteFormData } from './types'

interface RegisterWasteFormProps {
  setFormData: (formData: RegisterWasteFormData) => void
}

const FormRow = styled.div`
  width: 100%;
  margin-bottom: 15px;
`
const Input = styled.input`
  width: 100%;
  font-size: 16px;
  padding: 5px;
`

export function RegisterWasteForm({ setFormData }: RegisterWasteFormProps) {
  const [quantity, setQuantity] = useState<string>('0')

  useEffect(() => {
    setFormData({
      quantity,
    })
  }, [quantity, setFormData])

  return (
    <form>
      <FormRow>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor="quantity">
          <Row>
            <Col xs={8}>Quantity of waste, grams</Col>
            <Col xs={16}>
              <Input
                id="quantity"
                value={quantity}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setQuantity(e.target.value)
                }}
              />
            </Col>
          </Row>
        </label>
      </FormRow>
    </form>
  )
}
